<template>
  <div class="pt-table" v-if="hasPointsTable">
    <!-- <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" /> -->
    <!-- <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" /> -->
    <div v-for="(group, g_idx) in getStandingArr()" :key="g_idx">
      <div class="table-header" v-if="group[0] && group[0].group_name">
        <h2 class="title">{{ group[0].group_name }}</h2>
      </div>
      <div class="table-responsive points-table">
        <table class="table">
          <thead>
            <tr>
              <th v-for="(c, c_idx) in tableCols" :key="c_idx" :title="c.title">
                {{ c.displayName }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, t_idx) in group" :key="t_idx">
              <td v-for="(c, c_idx) in tableCols" :key="c_idx">
                <span class="qualifier-badge" v-if="c.showQualifer && t.is_qualified">Q</span>
                <span v-else>{{ t[c.key] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="no-data" v-else>
    <p class="msg">Points table not available for this series.</p>
    <p class="msg" v-if="pageOptionForNoPtsTable">
      {{pageOptionForNoPtsTable.preText}}
      <a class="no-data-link" :href="pageOptionForNoPtsTable.linkUrl">{{pageOptionForNoPtsTable.linkLabel}}</a>
      {{pageOptionForNoPtsTable.postText}}
    </p>
  </div>
</template>

<script>
// import GamezyAd from '../common/GamezyAd';
export default {
  props: ["hasPointsTable", "tableData", "pageOptionForNoPtsTable"],
  components: {
    // GamezyAd
  },
  data() {
    return {
      tableCols: [
        { displayName: "#", title: "Position", key: "team_position", showQualifer: true },
        { displayName: "Team", title: "Team Name", key: "team_name" },
        { displayName: "M", title: "Matches Played", key: "played" },
        { displayName: "W", title: "Wins", key: "wins" },
        { displayName: "L", title: "Lose", key: "lost" },
        { displayName: "Tied", title: "Tied", key: "tied" },
        { displayName: "N/R", title: "No Result", key: "noresult" },
        { displayName: "PTS", title: "Points", key: "points" },
        { displayName: "Net RR", title: "Net Run Rate", key: "net_run_rate" },
      ],
    };
  },
  methods: {
    getStandingArr() {
      var grouped = Object.values(
        this.tableData.reduce((acc, item) => {
          if (item.group_name) {
            acc[item.group_name] = [...(acc[item.group_name] || []), item];
          } else {
            acc["overall"] = [...(acc["overall"] || []), item];
          }

          return acc;
        }, {})
      );
      return grouped;
    },
  },
};
</script>